import axios from 'axios';
import jwt_decode from 'jwt-decode';

export const ACCESS_TOKEN = 'accessToken';
export const ROLE_ADMIN = 'admin';
export const ROLE_TEACHER = 'teacher';
export const ROLE_STUDENT = 'student';

export default class AuthService {
  constructor() {
    this.apiUrl = process.env.VUE_APP_API_BASE;
  }

  updateToken(token) {
    localStorage.setItem(ACCESS_TOKEN, token);
  }

  getToken() {
    return localStorage.getItem(ACCESS_TOKEN);
  }

  getDecoded() {
    try {
      return jwt_decode(this.getToken())
    } catch (err) {
      return null;
    }
  }

  isLogged() {
    const decoded = this.getDecoded();

    return typeof decoded === 'object' && decoded !== null;
  }

  hasRole(role) {
    const decoded = this.getDecoded();

    return decoded.roles.includes(role);
  }

  isAdmin() {
    return this.hasRole(ROLE_ADMIN);
  }

  isTeacher() {
    return this.hasRole(ROLE_TEACHER);
  }

  isStudent() {
    return this.hasRole(ROLE_STUDENT);
  }

  logoff() {
    localStorage.removeItem(ACCESS_TOKEN);
  }

  authenticate(email, password) {
    return axios
      .post(`${this.apiUrl}/user/login`, {
        email,
        password
      })
  }
}
